
import React from 'react'

/**
 *  This component displays the app's content centered in the middle of the screen, or fullscreen if the screen space
 *  is small.
 */
export default class AppContainer extends React.Component {

  constructor() {
    super()

    // Setup state
    this.state = {}
    this.state.isMobile = false

    // Bind functions
    this.onResize = this.onResize.bind(this)

  }

  componentDidMount() {

    // Add window resize listener
    window.addEventListener('resize', this.onResize)
    this.onResize()

  }

  componentWillUnmount() {

    // Remove window resize listener
    window.removeEventListener('resize', this.onResize)

  }

  render() {

    // Desktop style
    var desktopStyle = {
      width: 400,
      height: 500,
      border: '1px solid #D0D8DF',
      borderRadius: 8,
      overflow: 'hidden',
      position: 'relative'
    }

    // Mobile style
    var mobileStyle = {
      width: '100%',
      height: '100%',
      border: '0px solid #D0D8DF',
      borderRadius: 0,
      overflow: 'hidden',
      position: 'relative'
    }

    // Remove border if requested
    if (this.props.noPadding)
      desktopStyle = mobileStyle

    // Render centering container
    return <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

      {/* Render content container */}
      <div id='app-container' style={this.state.isMobile ? mobileStyle : desktopStyle}>

        {/* Render content */}
        {this.props.children}

      </div>

    </div>

  }

  onResize() {

    // Set mobile state
    this.setState({ isMobile: window.innerWidth < 410 || window.innerHeight < 510 })

  }

}
